import type { App } from 'vue'
import type { Store } from 'vuex'
import { AxiosError } from "axios"

const vuexHandledErrors = new WeakSet<object>()

export function vueErrorHandler (app: App, { store }: { store: Store<unknown> }) {
	app.config.errorHandler = err => {
		if (err !== null && typeof err === 'object' && vuexHandledErrors.has(err)) {
			return;
		}
		store.commit('ADD_ERROR', err)
	}

	window.addEventListener('unhandledrejection', event => {
		if (event.reason instanceof AxiosError) {
			event.preventDefault()
		}
	})
}

export function errorHandler (store: Store<unknown>) {
	store.subscribeAction({
		error (_action, _state, error) {
			if (error !== null && typeof error === 'object') {
				vuexHandledErrors.add(error)
			}
			store.commit('ADD_ERROR', error)
		}
	})
}
